(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    function attachSingleOpenBehavior(context = document) {
    const detailsList = context.querySelectorAll('.filter__details');

    detailsList.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (detail.open) {
          detailsList.forEach((other) => {
            if (other !== detail && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  }

  // Run on first page load
  document.addEventListener('DOMContentLoaded', () => {
    attachSingleOpenBehavior();

    // Reattach after Shopify AJAX filtering refresh
    document.addEventListener('shopify:section:load', (e) => {
      attachSingleOpenBehavior(e.target);
    });

    // Reattach after facet filter redraw (used in Online Store 2.0)
    document.addEventListener('facets:updated', (e) => {
      attachSingleOpenBehavior(e.target);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
